var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManDarkSkinToneSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C533E",
    d: "M8 19c0 2.209-1.119 4-2.5 4S3 21.209 3 19s1.119-4 2.5-4S8 16.791 8 19zm25 0c0 2.209-1.119 4-2.5 4S28 21.209 28 19s1.119-4 2.5-4s2.5 1.791 2.5 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C533E",
    d: "M5 20.562c0-8.526 5.82-15.438 13-15.438s13 6.912 13 15.438S25.18 36 18 36S5 29.088 5 20.562z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1zm10 0a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D2E24",
    d: "M19 24h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0200",
    d: "M25.274 27.038l-3.294-.941c.003-.034.02-.063.02-.097a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1c0 .034.016.063.019.097l-3.294.941a1 1 0 0 0 .55 1.924l1.931-.552a.993.993 0 0 0-.1 1.037a.998.998 0 0 0 1.341.448l1.577-.788a.98.98 0 0 0 .529.788a1.003 1.003 0 0 0 1.342-.448l.105-.211l.105.211a1 1 0 0 0 1.342.448a.982.982 0 0 0 .529-.788l1.576.788a1 1 0 0 0 1.343-.448a.993.993 0 0 0-.1-1.037l1.931.552a1.001 1.001 0 0 0 .548-1.924zM18 0c8.615 0 14 6.358 14 11.656c0 5.298-1.077 7.417-2.154 5.298l-2.153-4.238s-6.462 0-8.615-2.12c0 0 3.23 6.358-3.231 0c0 0 1.077 4.239-5.385-1.06c0 0-3.23 2.12-4.308 7.417C5.855 18.423 4 16.954 4 11.656C4 6.357 8.308 0 18 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManDarkSkinToneSvgrepoCom);
export default __webpack_public_path__ + "static/media/man-dark-skin-tone-svgrepo-com.e2699ec8d2474425629e040d0d49015f.svg";
export { ForwardRef as ReactComponent };